import { getConfig } from '@edx/frontend-platform';
import { Link } from 'react-router-dom';
import { useIntl } from '@edx/frontend-platform/i18n';

import { ROUTES } from '@src/routes';
import messages from './messages';

const FooterBrandMark = () => (
  <svg
    className="catalog-landing-footer__brand-icon"
    width="28"
    height="28"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M13 3.25L18.25 5.35V12.1C18.25 16.1 15.73 19.77 13 21.15C10.27 19.77 7.75 16.1 7.75 12.1V5.35L13 3.25Z"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinejoin="round"
    />
    <path
      d="M13 7.2V14.2"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
    />
    <path
      d="M10.05 23L13 20.1L15.95 23"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PublicCatalogFooter = () => {
  const intl = useIntl();
  const currentYear = new Date().getFullYear();
  const config = getConfig();

  const footerLinks = [
    {
      title: intl.formatMessage(messages.footerPlatformTitle),
      links: [
        {
          label: intl.formatMessage(messages.footerPlatformExploreCourses),
          to: ROUTES.COURSES,
        },
      ],
    },
    {
      title: intl.formatMessage(messages.footerResourcesTitle),
      links: [
        {
          label: intl.formatMessage(messages.footerResourcesAbout),
          to: ROUTES.ABOUT,
        },
        {
          label: intl.formatMessage(messages.footerResourcesFaq),
          to: ROUTES.FAQ,
        },
        {
          label: intl.formatMessage(messages.footerResourcesHelp),
          to: ROUTES.HELP,
        },
      ],
    },
    {
      title: intl.formatMessage(messages.footerLegalTitle),
      links: [
        {
          label: intl.formatMessage(messages.footerLegalTerms),
          to: ROUTES.LEGAL_TERMS,
        },
        {
          label: intl.formatMessage(messages.footerLegalPrivacy),
          to: ROUTES.LEGAL_PRIVACY,
        },
      ],
    },
  ];

  const footerSocials = [
    {
      label: intl.formatMessage(messages.footerSocialTwitter),
      href: config.SOCIAL_LINK_TWITTER || config.TWITTER_URL,
    },
    {
      label: intl.formatMessage(messages.footerSocialLinkedIn),
      href: config.SOCIAL_LINK_LINKEDIN || config.LINKEDIN_URL,
    },
  ].filter((social) => Boolean(social.href));

  return (
    <footer className="catalog-landing-footer">
      <div className="catalog-landing-footer__container">
        <div className="catalog-landing-footer__brand-block">
          <div className="catalog-landing-footer__brand">
            <FooterBrandMark />
            <span>WutiSkill</span>
          </div>
          <p className="catalog-landing-footer__summary">
            {intl.formatMessage(messages.footerSummary)}
          </p>
        </div>

        {footerLinks.map((group) => (
          <div key={group.title} className="catalog-landing-footer__group">
            <h3>{group.title}</h3>
            <ul>
              {group.links.map((link) => (
                <li key={link.label}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="catalog-landing-footer__bottom">
        <div className="catalog-landing-footer__bottom-inner">
          <span className="catalog-landing-footer__copyright">
            {intl.formatMessage(messages.footerCopyright, { year: currentYear })}
          </span>
          {footerSocials.length ? (
            <div className="catalog-landing-footer__socials">
              {footerSocials.map((social) => (
                <a key={social.label} href={social.href} target="_blank" rel="noreferrer">
                  {social.label}
                </a>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </footer>
  );
};

export default PublicCatalogFooter;
